import script from "./NewMatch.vue?vue&type=script&setup=true&lang=js"
export * from "./NewMatch.vue?vue&type=script&setup=true&lang=js"

import "./NewMatch.vue?vue&type=style&index=0&id=67b6d3be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67b6d3be"]])

export default __exports__